<template>
    <div class="home">
        <div class="homebg" :class="dong ? 'donghua' : ''">
            <img src="../static/homewords.png" class="homewords" alt="">
            <img src="../static/homebut.png" class="homebut" @click="toscene" alt="">
            <img src="../static/hometitle.png" class="hometitle" alt="">
        </div>

        <audio id="click" :src="require('@/static/click.mp3')"></audio>
        <div class="scene">
 
            <p :class="music ? 'music zhuan' : 'music'"></p>
            <img src="../static/bg.png" class="bg" alt="">
            
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dong: false,
            music:true,
        }
    },
    methods: {
        toscene() {
            this.dong = true
            document.getElementById('click').play();
            setTimeout(() => {
                this.$router.push('/scene')
            }, 1000);
            
        },

    },
}
</script>

<style lang="less">
.home {
    width: 100%;
    height: 100%;

    .donghua {
        animation: bg-ani 2s ease 1 forwards;

        @keyframes bg-ani {
            0% {
                top: 0;
            }

            100% {
                top: -230%;
            }
        }
    }

    .homebg {
        position: absolute;
        width: 100%;
        height: 100vh;
        background: url(../static/home-bg.png) no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        top: 0;
        left: 0;
        z-index: 22;
        .homewords {
            position: absolute;
            width: 170px;
            left: 30px;
            top: 60px;
            animation: words-ani 3s ease 1 forwards;

            @keyframes words-ani {
                0% {
                    opacity: 0;
                }

                40% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .homebut {
            position: absolute;
            width: 150px;
            right: 0px;
            bottom: 35%;
            animation: but-ani 4s ease 1 forwards;

            @keyframes but-ani {
                0% {
                    opacity: 0;
                }

                70% {
                    opacity: 0;
                }

                100% {
                    opacity: 1;
                }
            }
        }

        .hometitle {
            position: absolute;
            width: 120px;
            right: 30px;
            top: 70px;
            animation: title-ani 2s ease 1 forwards;

            @keyframes title-ani {
                0% {
                    right: -90px;
                }

                100% {
                    right: 30px;
                }
            }
        }
    }
    .scene{
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: hidden;

        .bg{
            width: 100%;
            display: block;
        }
        .music {
            position: fixed;
            width: 50px;
            height: 50px;
            top: 35px;
            right: 20px;
            background: url("../static/music.png") center no-repeat;
            background-size: 100% 100%;
            z-index: 5;

            &.zhuan {
                animation: turn 2s linear infinite;

                @keyframes turn {
                    0% {
                        -webkit-transform: rotate(0deg);
                    }

                    25% {
                        -webkit-transform: rotate(90deg);
                    }

                    50% {
                        -webkit-transform: rotate(180deg);
                    }

                    75% {
                        -webkit-transform: rotate(270deg);
                    }

                    100% {
                        -webkit-transform: rotate(360deg);
                    }
                }
            }
        }

    }
}
</style>